import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Formik } from 'formik'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Textarea } from 'components/Forms'

import { closeModal } from 'store/actions/modals'
import { hashTable } from 'services/Utilities'
import { t } from 'translations'

function PasteEmployeeNumbersModal({ setSelection }) {
  const dispatch = useDispatch()
  const { users } = useSelector(state => state.resources)

  // Create a map by employeeNumber
  const usersByEmployeeNumbers = hashTable(users, 'employeeNumber')
  // Create an array of employee numbers depending on how they have been pasted in the text area
  const employeeNumbersArray = value => {
    return value.trim().replace(/\n|,/g, ' ').replace(/ +/g, ' ').split(' ')
  }
  // Validation function to check if the employee numbers exist
  const validateNumbers = value => {
    let error
    let invalidNumbers = []
    employeeNumbersArray(value).forEach(number => {
      if (!usersByEmployeeNumbers[number]) {
        invalidNumbers.push(number)
        error = t(`manager.users.INVALID_EMPLOYEE_NUMBERS`, { invalidNumbers: invalidNumbers.join(', ') })
      }
    })
    return error
  }
  // OnSubmit function
  const pasteEmployeeNumbers = ({ employeeNumbers }) => {
    const selectedEmployees = {}
    employeeNumbersArray(employeeNumbers).forEach(number => {
      selectedEmployees[usersByEmployeeNumbers[number]._id] = true
    })
    setSelection('users', selectedEmployees)
    dispatch(closeModal())
  }
  return (
    <BaseModal hideButtons title={`manager.users.PASTE_EMPLOYEE_NUMBERS`}>
      <Formik onSubmit={pasteEmployeeNumbers} enableReinitialize={true} initialValues={{ employeeNumbers: '' }} validateOnChange={false} validateOnBlur={false}>
        {({ isSubmitting, setFieldValue }) => {
          return (
            <Form>
              <div>
                <Textarea
                  className="mt-3"
                  module="manager.users"
                  name="employeeNumbers"
                  validate={validateNumbers}
                  style={{ height: '150px' }}
                  onChange={({ target }) => setFieldValue('employeeNumbers', target.value.trim())}
                />
              </div>

              {/* Submit & Close buttons */}
              <div className="mt-2">
                <Button type="submit" isSubmitting={isSubmitting} text="actions.SUBMIT" className="btn btn-primary mr-2" />
                <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
              </div>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default PasteEmployeeNumbersModal
